(function () {
    'use strict';

    function assert(item) {
        if (!item) {
            throw Error("PageIndicator not yet initialized");
        }
    }
    class PageIndicator {
        constructor({ className, carousel }) {
            this.pageIndicatorItems = [];
            this.carousel = carousel;
            this.className = className;
            this.classes = {
                active: `${this.className}__page-indicator__item--active`,
                wrapper: `${this.className}__page-indicator-wrapper`,
                flex: `${this.className}__page-indicator-flex`,
                item: `${this.className}__page-indicator__item`,
            };
        }
        create({ total, index }) {
            const pageIndicatorWrapper = document.createElement("div");
            pageIndicatorWrapper.classList.add(this.classes.wrapper);
            const pageIndicatorFlex = document.createElement("div");
            pageIndicatorFlex.classList.add(this.classes.flex);
            const pageIndicator = document.createElement("ul");
            pageIndicator.classList.add(`${this.className}__page-indicator`);
            this.pageIndicatorItems = [...Array(total)].map((_, i) => {
                const title = `go to ${i + 1}/${total}`;
                const li = document.createElement("li");
                li.elementIndex = i;
                li.classList.add(this.classes.item, i === index ? this.classes.active : this.classes.item);
                const button = document.createElement("button");
                button.setAttribute("type", "button");
                button.title = title;
                li.title = title;
                li.appendChild(button);
                pageIndicator.appendChild(li);
                return li;
            });
            pageIndicatorWrapper.appendChild(pageIndicatorFlex);
            pageIndicatorFlex.appendChild(pageIndicator);
            const carousel = this.carousel.getElement();
            // kick old page indicator when already in dom (sonderlocke for ft find)
            const old = carousel.querySelector(`.${this.classes.wrapper}`);
            if (old) {
                carousel.replaceChild(pageIndicatorWrapper, old);
            }
            else {
                carousel.appendChild(pageIndicatorWrapper);
            }
            // do not react to touch events
            pageIndicator.addEventListener("touchstart", (event) => {
                event.preventDefault();
            });
            pageIndicator.addEventListener("click", (event) => {
                const target = event.target.closest(`.${this.className}__page-indicator__item`);
                event.preventDefault();
                if (target) {
                    this.carousel.move({ index: target.elementIndex });
                }
            });
            this.pageIndicatorElement = pageIndicator;
            this.translate({ index, scrollingRight: true });
            return this;
        }
        update({ index, scrollingRight }) {
            var _a;
            assert(this.pageIndicatorElement);
            (_a = this.pageIndicatorElement
                .querySelector(`.${this.classes.active}`)) === null || _a === void 0 ? void 0 : _a.classList.remove(this.classes.active);
            this.pageIndicatorItems[index].classList.add(this.classes.active);
            this.translate({
                index,
                scrollingRight,
            });
        }
        translate({ index, scrollingRight }) {
            var _a, _b;
            if (this.pageIndicatorItems.length > 6) {
                const max = this.pageIndicatorItems.length;
                let translate;
                const rightEdge = max - 4;
                const leftEdge = 4;
                const width = 12;
                const gap = 3;
                this.pageIndicatorItems.forEach((item) => {
                    item.classList.remove("small");
                });
                if (index > rightEdge) {
                    this.pageIndicatorItems[max - 7].classList.add("small");
                }
                else if (index <= rightEdge && index >= leftEdge) {
                    this.pageIndicatorItems[index - gap].classList.add("small");
                    this.pageIndicatorItems[index + gap].classList.add("small");
                    (_a = this.pageIndicatorItems[index - gap - 1]) === null || _a === void 0 ? void 0 : _a.classList.add("small");
                    (_b = this.pageIndicatorItems[index + gap + 1]) === null || _b === void 0 ? void 0 : _b.classList.add("small");
                }
                else if (index < leftEdge) {
                    this.pageIndicatorItems[6].classList.add("small");
                }
                // scrolling in right direction
                if (scrollingRight) {
                    if (index > rightEdge) {
                        translate = this.pageIndicatorItems[max - 7].offsetLeft;
                    }
                    else if (index > 2) {
                        translate = this.pageIndicatorItems[index].offsetLeft - gap * width;
                    }
                }
                else if (index > gap && index < rightEdge) {
                    translate = this.pageIndicatorItems[index].offsetLeft - gap * width;
                }
                else if (index < leftEdge) {
                    translate = 0;
                }
                if (typeof translate !== "undefined" && this.pageIndicatorElement) {
                    this.pageIndicatorElement.style.transform = `translateX(-${translate}px)`;
                }
            }
        }
    }

    class Arrows {
        constructor({ window, className, prev, next, total, carousel, }) {
            /*
          
            how many milliseconds the arrow is still visible -
            to prevent unintentionally clicks on the slide
            when the user reaches the first or last slide
          
            */
            this.delay = 500;
            this.window = window;
            this.className = className;
            this.total = total;
            this.prev = prev;
            this.next = next;
            this.classes = {
                hiddenArrow: `${this.className}__arrow--hidden`,
                airbag: `${this.className}__arrow--airbag`,
            };
            this.carousel = carousel;
            return this;
        }
        init() {
            [this.prev, this.next].forEach((arrow) => {
                arrow.addEventListener("click", (e) => {
                    e.preventDefault();
                    if (arrow === this.next) {
                        this.carousel.scrollNext();
                    }
                    else {
                        this.carousel.scrollPrev();
                    }
                });
            });
            return this;
        }
        airbag(arrow) {
            arrow.classList.add(this.classes.hiddenArrow);
            arrow.classList.add(this.classes.airbag);
            this.window.setTimeout(() => {
                arrow.classList.remove(this.classes.airbag);
            }, this.delay);
        }
        update({ index, total }) {
            if (index === 0) {
                this.airbag(this.prev);
            }
            else {
                this.prev.classList.remove(this.classes.hiddenArrow);
            }
            if (index === total - 1) {
                this.airbag(this.next);
            }
            else {
                this.next.classList.remove(this.classes.hiddenArrow);
            }
        }
    }

    /*
    https://caniuse.com/?search=IntersectionObserver
     */
    function hasIntersectionObserver(window) {
        return ("IntersectionObserver" in window &&
            "IntersectionObserverEntry" in window &&
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            "intersectionRatio" in window.IntersectionObserverEntry.prototype &&
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            "isIntersecting" in window.IntersectionObserverEntry.prototype);
    }
    /* https://caniuse.com/?search=documentelement */
    function hasScrollBehaviour(window) {
        return "scrollBehavior" in window.document.documentElement.style;
    }

    class SlidingCarousel {
        constructor(window, element) {
            var _a;
            this.className = "pl_sliding-carousel";
            this.wait = [];
            this.classes = {
                ready: `${this.className}--ready`,
                activeSlide: `${this.className}__slide--active`,
                arrow: `${this.className}__arrow`,
                fallback: `${this.className}--fallback`,
            };
            this.carousel = element;
            this.slides = Array.from(this.carousel.querySelectorAll(`.${this.className}__slide`)).map((slide, index) => {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                slide.elementIndex = index;
                return slide;
            });
            this.total = this.slides.length;
            this.stage = this.carousel.querySelector(`.${this.className}__stage`);
            // get active slide index, IE11 has no .find(), so we use .filter()
            this.activeSlideIndex =
                ((_a = Array.from(this.slides).filter((slide) => {
                    return slide.classList.contains(this.classes.activeSlide);
                })[0]) === null || _a === void 0 ? void 0 : _a.elementIndex) || 0;
            this.lastActiveSlideIndex = this.activeSlideIndex;
            this.pageIndicator =
                this.carousel.dataset.slidingCarouselHidePageIndicator || this.total < 2
                    ? undefined
                    : new PageIndicator({ className: this.className, carousel: this }).create({
                        total: this.total,
                        index: this.activeSlideIndex,
                    });
            const [prev, next] = Array.from(this.carousel.querySelectorAll(`.${this.classes.arrow}`));
            this.arrows = new Arrows({
                window,
                className: this.className,
                prev,
                next,
                total: this.total,
                carousel: this,
            }).init();
            this.window = window;
            this.hasIntersectionObserver = hasIntersectionObserver(this.window);
            return this;
        }
        getElement() {
            return this.carousel;
        }
        scrollNext() {
            if (this.activeSlideIndex < this.total - 1) {
                // eslint-disable-next-line no-plusplus
                this.activeSlideIndex++;
                this.move({ index: this.activeSlideIndex });
            }
        }
        scrollPrev() {
            if (this.activeSlideIndex > 0) {
                // eslint-disable-next-line no-plusplus
                this.activeSlideIndex--;
                this.move({ index: this.activeSlideIndex });
            }
        }
        update(index) {
            var _a, _b;
            const scrollingRight = index >= this.lastActiveSlideIndex;
            if (index !== this.lastActiveSlideIndex) {
                this.wait.push(this.window.setTimeout(() => {
                    this.wait.pop();
                    if (this.wait.length === 0) {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        this.window.o_global.eventQBus.emit("assets.slidingcarousel.change", {
                            currentSlide: index,
                            element: this.carousel,
                        });
                    }
                }, 1000));
            }
            this.activeSlideIndex = index;
            this.lastActiveSlideIndex = this.activeSlideIndex;
            (_a = this.pageIndicator) === null || _a === void 0 ? void 0 : _a.update({ index, scrollingRight });
            this.arrows.update({ index, total: this.total });
            (_b = this.carousel
                .querySelector(`.${this.classes.activeSlide}`)) === null || _b === void 0 ? void 0 : _b.classList.remove(this.classes.activeSlide);
            this.slides[index].classList.add(this.classes.activeSlide);
        }
        move({ index }) {
            this.stage.scrollLeft = this.slides[index].offsetLeft;
            if (!this.hasIntersectionObserver) {
                this.update(index);
            }
        }
        init() {
            // when the markup comes from the client side's cache, there might be a ready class
            this.carousel.classList.remove(this.classes.ready);
            // do nothing when there is only a single slide
            if (this.total < 2) {
                return this;
            }
            this.carousel.addEventListener("keyup", (e) => {
                const { key } = e;
                console.log(key);
                if (key === "ArrowLeft") {
                    this.scrollPrev();
                }
                else if (key === "ArrowRight") {
                    this.scrollNext();
                }
            });
            const doThings = (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const target = entry.target;
                        const { elementIndex: index } = target;
                        this.update(index);
                    }
                });
            };
            const observer = this.hasIntersectionObserver
                ? // eslint-disable-next-line compat/compat
                    new IntersectionObserver(doThings, {
                        root: this.stage,
                        rootMargin: "0px",
                        threshold: 0.51,
                    })
                : null;
            /*
        
              IE, Edge (12 - 16) and Safari do not support smooth scroll behavior.
              slides are not moving.
        
            */
            if (!hasScrollBehaviour(this.window)) {
                this.carousel.classList.add(this.classes.fallback);
            }
            this.stage.scrollLeft = this.slides[this.activeSlideIndex].offsetLeft;
            this.slides[this.activeSlideIndex].classList.add(this.classes.activeSlide);
            if (!this.hasIntersectionObserver) {
                this.update(this.activeSlideIndex);
            }
            this.slides.forEach((slide) => {
                observer === null || observer === void 0 ? void 0 : observer.observe(slide);
            });
            this.carousel.classList.add(this.classes.ready);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.window.o_global.eventQBus.emit("assets.slidingcarousel.initialized", {
                element: this.carousel,
            });
            return this;
        }
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.o_global.eventQBus.on("assets.slidingcarousel.init", (selector = ".js_pl_sliding-carousel:not([data-pl-sliding-carousel-skip-init])") => {
        const carousels = document.querySelectorAll(selector);
        Array.from(carousels).forEach((c) => {
            new SlidingCarousel(window, c).init();
        });
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.o_global.eventLoader.onAllScriptsExecuted(130, () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.o_global.eventQBus.emit("assets.slidingcarousel.init");
    });

})();
